import { defineMessages } from "react-intl";

export default defineMessages({
  onlineBookingTitle: {
    id: "Patient.PatientAgeAlert.onlineBookingTitle",
    defaultMessage: "This appointment cannot be booked online",
  },
  onlineBookingDescription: {
    id: "Patient.PatientAgeAlert.onlineBookingDescription",
    defaultMessage:
      "The patient is under the age of {minOnlineBookingAge} so please call {centerName} at {centerPhone} to book your appointment",
  },
  selfBookingTitle: {
    id: "Patient.PatientAgeAlert.selfBookingTitle",
    defaultMessage: "This appointment cannot be saved",
  },
  selfBookingDescription: {
    id: "Patient.PatientAgeAlert.selfBookingDescription",
    defaultMessage:
      "The patient is under the age of {minSelfBookingAge} so the appointment must be booked by the patient's legal guardian",
  },
});
